import React from 'react';
import {connect} from 'react-redux';
import {colors} from '../styles/colors';
import {translate} from 'react-i18next';
import InfoSnack from '../utils/InfoSnack';
import List from 'material-ui/List';
import {workoutFetchData} from '../workout/WorkoutAction';
import ReactDOM from 'react-dom';
import moment from 'moment';
import {LinearProgress} from 'material-ui';
import {navigationBack} from '../navigation/NavigationActions';
import ArrowBack from 'material-ui-icons/ArrowBack';
import successIcon from '../images/success.svg';
import achievement from '../images/achievement.svg';
import '../pulseAnimation.css';
import MyButton from '../components/MyButton';

class SuccessScreen extends React.PureComponent {
	render() {
		const {t} = this.props;

		return (
			<div>
				<div style={styles.containerShadowBox}>
					<div style={styles.containerInner}>
						<img
							style={styles.successIcon}
							src={successIcon}
							alt='Logo'
						/>

						<h1 style={{textAlign: 'center', maxWidth: 300}}>
							{t('success:congratulationTitle')}
						</h1>
						<h3
							style={{
								paddingTop: 35,
								textAlign: 'center',
								maxWidth: 300,
							}}
						>
							{t('success:congratulationDescription')}
						</h3>

						<MyButton
							style={{marginTop: 35}}
							onPressButton={() => this.props.goBack()}
							title={this.props.t('common:next')}
							color='secondary'
							loading={false}
							variant='raised'
						/>
					</div>
				</div>
			</div>
		);
	}

	onPressItem = (item) => {};
}

const styles = {
	containerShadowBox: {
		height: '100vh',
		margin: '0 auto',
		background:
			'linear-gradient(0deg, rgba(26,33,43,1) 0%, rgba(9,9,121,1) 32%, rgba(24,178,206,1) 100%)',
		alignItems: 'center',
		justifyContent: 'center',
		display: 'flex',
		color: colors.white,
		padding: 15,
	},
	containerInner: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
	},
	successIcon: {
		marginBottom: 30,
		animation: 'pulse 2s ease infinite',
	},
	flex: {
		flex: 1,
	},
	profileInfoContainer: {
		maxWidth: 1200,
		margin: '0 auto',
		padding: 16,
	},
	profileInfoOuter: {
		backgroundColor: colors.primaryColor,
		width: '100%',
	},
	paddingToBar: {
		paddingTop: 56,
	},
	profileInfo: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: colors.white,
		padding: 16,
		borderRadius: 4,
		boxShadow: `0 1px 3px 0 rgba(41,70,97,.2)`,
	},
	loadingIndicator: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginTop: 24,
	},
	workingInline: {
		paddingTop: 56,
		marginTop: -56,
	},
	payoutDescription: {
		color: colors.text_light,
		marginBottom: 12,
	},
	payoutTitleContainer: {
		display: 'flex',
		flexDirection: 'row',
	},
	payoutTitle: {
		flex: 1,
	},
	payoutAmount: {
		color: colors.white,
		backgroundColor: colors.primaryColor,
		borderRadius: 4,
		paddingTop: 2,
		paddingBottom: 2,
		paddingLeft: 6,
		paddingRight: 6,
	},
};

const mapDispatchToProps = (dispatch) => {
	return {
		goBack: () => dispatch(navigationBack()),
	};
};

export default connect(
	null,
	mapDispatchToProps
)(translate(['success', 'common'])(SuccessScreen));



// WEBPACK FOOTER //
// ./src/success/SuccessScreen.js